import { Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'
import UserAccount from '../UserAccount'
import GenealogyCard from 'Components/Elements/Genealogy/GenealogyCard'
import MobileLayoutWrapper from 'Components/Elements/UserAccountMenu/MobileLayoutWrapper'
import styled from '@emotion/styled'
import { storeElement } from 'GlobalStores/StoreElement'
import storeAuth from 'GlobalStores/User/StoreAuth'
import { IconSpinner } from 'Components/Elements/Spinner/IconSpinner'
import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import { storeElement as storeElementGlobal } from 'GlobalStores/Cores/Elements/StoreElement'

const GenealogyPage = observer(() => {
    useEffect(() => {
        runInAction(() => {
            storeElementGlobal.cardTitle.titleStep1 = <T>genealogy</T>
            storeElementGlobal.settingCard.title = ''
            storeElementGlobal.settingCard.padding = ''
        })

        return () => {
            runInAction(() => {
                storeElementGlobal.cardTitle.titleStep1 = ''
                storeElementGlobal.settingCard.padding = ''
            })
        }
    }, [])

    return (
        <>
            {storeAuth.IsAuthorized() ? (
                <>
                    {storeElement.IsMobile() ? (
                        <WrapperMobileLayout>
                            <GenealogyCard />
                        </WrapperMobileLayout>
                    ) : (
                        <UserAccount>
                            <GenealogyCard />
                        </UserAccount>
                    )}
                </>
            ) : (
                <Stack height={'100dvh'} display={'flex'} alignItems={'center'} justifyContent={'center'} flex={1}>
                    <IconSpinner />
                </Stack>
            )}
        </>
    )
})

export const WrapperMobileLayout = observer(props => {
    return (
        <MobileLayoutWrapper sx={{ padding: '0px!important' }}>
            <StackMobileLayout>
                <Stack width={'100%'}>{props.children}</Stack>
            </StackMobileLayout>
        </MobileLayoutWrapper>
    )
})

const StackMobileLayout = styled(Stack)`
    align-items: center;
    background: #d1d9e2 !important;
    display: flex;
    width: 100%;

    .mobile-layout-box {
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        background-color: #fff;
        box-shadow: 0px 1px 2px rgba(14, 35, 56, 0.2);
        border-radius: 12px;
    }

    @media screen and (min-width: 414px) {
        .mobile-layout-box {
            /* width: 384px; */
        }
    }
`
const DesktopLayout = styled('div')`
    box-sizing: border-box;
    width: 100%;
    padding: 32px;
    background-color: #fff;
    border-radius: 12px;
`

export default GenealogyPage
